export default {"src":"/_next/static/media/valid.a4e796ec.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};